var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvChargerFill0Wght400Grad0Opsz241({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 28.5L16.5 22.5H14.25V18L10.5 24H12.75V28.5ZM9 15H18V7.5H9V15ZM9 28.5H18V18H9V28.5ZM6 31.5V7.5C6 6.675 6.29375 5.96875 6.88125 5.38125C7.46875 4.79375 8.175 4.5 9 4.5H18C18.825 4.5 19.5313 4.79375 20.1188 5.38125C20.7063 5.96875 21 6.675 21 7.5V18H22.875C23.6 18 24.2188 18.2563 24.7313 18.7688C25.2438 19.2813 25.5 19.9 25.5 20.625V27.5625C25.5 27.9875 25.675 28.375 26.025 28.725C26.375 29.075 26.7625 29.25 27.1875 29.25C27.6375 29.25 28.0312 29.075 28.3688 28.725C28.7063 28.375 28.875 27.9875 28.875 27.5625V13.5H28.5C28.075 13.5 27.7188 13.3563 27.4313 13.0688C27.1438 12.7812 27 12.425 27 12V9H27.75V6.75H29.25V9H30.75V6.75H32.25V9H33V12C33 12.425 32.8563 12.7812 32.5688 13.0688C32.2813 13.3563 31.925 13.5 31.5 13.5H31.125V27.5625C31.125 28.6125 30.7438 29.5313 29.9813 30.3188C29.2188 31.1063 28.2875 31.5 27.1875 31.5C26.1125 31.5 25.1875 31.1063 24.4125 30.3188C23.6375 29.5313 23.25 28.6125 23.25 27.5625V20.625C23.25 20.5 23.2188 20.4063 23.1562 20.3438C23.0938 20.2813 23 20.25 22.875 20.25H21V31.5H6Z",
    fill: "#738395"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvChargerFill0Wght400Grad0Opsz241);
export default __webpack_public_path__ + "static/media/ev_charger_FILL0_wght400_GRAD0_opsz24 1.6848dc30b996bbf73f8e3ddd98e74680.svg";
export { ForwardRef as ReactComponent };